import { useState, useCallback } from 'react';

/**
 * @param {string} [label]
 * @param {(next: boolean) => void} [onChange]
 * @param {import('react').CSSProperties} [style]
 * @param {boolean} [checked] — when set, controlled mode
 * @param {boolean} [defaultChecked] — initial value when uncontrolled
 */
export default function Toggle({ label, onChange, style, checked, defaultChecked = false }) {
    const [internalChecked, setInternalChecked] = useState(defaultChecked);
    const isControlled = checked !== undefined;
    const isOn = isControlled ? checked : internalChecked;

    const handleChange = useCallback(
        (e) => {
            const next = e.target.checked;
            if (!isControlled) setInternalChecked(next);
            onChange?.(next);
        },
        [isControlled, onChange]
    );

    return (
        <label
            style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                justifyContent: 'flex-end',
                userSelect: 'none',
                WebkitUserSelect: 'none',
                ...style,
            }}
        >
            <input
                type="checkbox"
                checked={isOn}
                onChange={handleChange}
                style={{ marginRight: '8px' }}
            />
            {label}
        </label>
    );
}
